import { useState } from 'react';

import * as Apis from 'apis';
import { AJAX_DEBOUNCE_ACTION_TYPES, AJAX_END_TIMEOUT, SERVICE_PROVIDER } from 'configs/fetchApi';
import Context from './Context';

const { START, END, FAIL, SUCCESS } = AJAX_DEBOUNCE_ACTION_TYPES;
const Provider = ({ children }) => {
    const [apis] = useState(Apis);
    const [apiStatus, setApiStatus] = useState({});
    const [tpStore, setTpStore] = useState({});
    const [serverStore, setServerStore] = useState({});
    const [lineStore, setLineStore] = useState({});
    let tmpApiStatus = apiStatus,
        tmpStore = {
            [SERVICE_PROVIDER.SEVER]: serverStore,
            [SERVICE_PROVIDER.TAPPIE]: tpStore,
            [SERVICE_PROVIDER.LINE]: lineStore
        };

    const setStore = (storeKey, storeName, data) => {
        tmpStore = {
            ...tmpStore,
            [storeKey]: { ...tmpStore[storeKey], [storeName]: data }
        };
        const storeValue = { ...tmpStore[storeKey], [storeName]: data };
        switch (storeKey) {
            case SERVICE_PROVIDER.SEVER:
                setServerStore(storeValue);
                break;
            case SERVICE_PROVIDER.TAPPIE:
                setTpStore(storeValue);
                break;
            case SERVICE_PROVIDER.LINE:
                setLineStore(storeValue);
                break;
            default:
                break;
        }
    };

    const updateApiStatus = (key, type) => {
        tmpApiStatus = { ...tmpApiStatus, [key]: `${type}/${key}` };
        setApiStatus(tmpApiStatus);
    };

    const useWatch = () => {
        return {
            ...tpStore,
            ...lineStore,
            ...serverStore
        };
    };

    const useValue = (key) => {
        return {
            ...tpStore,
            ...lineStore,
            ...serverStore
        }[key];
    };

    const withApis = (apis = []) => {
        return Promise.all(
            apis.map(async (api = () => {}) => {
                console.log(api);
                const { key: apiKey, storeName, storeKey, callback } = api;
                const key = apiKey.toUpperCase();

                if (apiStatus[key] && !(apiStatus[key] || '').startsWith(`${END}/`)) return;

                updateApiStatus(key, START);

                const res = await callback();
                console.log('res', res);
                if (res.err) {
                    updateApiStatus(key, FAIL);
                } else {
                    updateApiStatus(key, SUCCESS);

                    setStore(storeKey, storeName, res.data);
                    setTimeout(() => {
                        updateApiStatus(key, END);
                    }, AJAX_END_TIMEOUT);
                }
                return res;
            })
        );
    };
    const props = {
        withApis,
        apis,
        useWatch,
        useValue
    };

    return <Context.Provider value={{ ...props }}>{children}</Context.Provider>;
};

export default Provider;
